import { handleResponseErr } from '../../utils/handleResponseErr'
/*
* Login Reducer
*/
const DEFAULT_STATE = {
  successLogin: false,
  loading: false,
  errMsg: null,
  token: null,
}

export default function auth (state = DEFAULT_STATE, action) {
  switch (action.type){
    case "LOGIN_REQUEST_PENDING":
      return {...DEFAULT_STATE, loading: true}

    case "LOGIN_REQUEST_FULFILLED":
      return {
        ...DEFAULT_STATE,
        successLogin: true,
        user: action.payload.data.data.user,
        token: action.payload.data.data.auth_token,
      }

    case "LOGIN_REQUEST_REJECTED":
      return {
        ...DEFAULT_STATE,
        errMsg: handleResponseErr(action.payload)
      }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/auth.js